import { useState, useCallback } from "react";
import axios, { AxiosError } from "axios";
import { ContactFormValues } from "../../../../components/contact/form/props";
import { maskPhone } from "../../../../utils/common";
import { useToast } from "@ui/hooks/use-toast";

interface UseSendContactEmailResult {
  sendContactEmail: (data: ContactFormValues) => Promise<void>;
  loading: boolean;
}

export function useSendContactEmail(): UseSendContactEmailResult {
  const [loading, setLoading] = useState(false);

  const { toast } = useToast();

  const sendContactEmail = useCallback(async (data: ContactFormValues) => {
    setLoading(true);

    try {
      await axios.post("/api/click-autos-contact", {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: maskPhone(data.phone),
        message: data.message,
      });

      toast({
        title: "Tudo certo",
        description:
          "Sua mensagem foi enviada com sucesso, aguarde nosso contato!",
        variant: "success",
      });
    } catch (err) {
      toast({
        title: "Oops! Algo deu errado",
        description: "Tente novamente mais tarde.",
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    sendContactEmail,
    loading,
  };
}
